'use client';

import React, { FC, PropsWithChildren, Suspense, useEffect, useState } from 'react';

import Loading from '@/components/Loading/loading';

// The full-screen loader is shown only during the first page load.
// Changing language remounts the whole [lang] layout; a new Suspense boundary would show
// the loader again, so without it the router keeps the current page until the new one is ready.
let isFirstLoad = true;

const InitialLoadSuspense: FC<PropsWithChildren> = ({ children }) => {
  const [withLoader] = useState(isFirstLoad);

  useEffect(() => {
    isFirstLoad = false;
  }, []);

  if (!withLoader) {
    return <>{children}</>;
  }

  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default InitialLoadSuspense;
